import React from 'react';
import {lang} from 'js/Core/lang';

export const SubmitContainer = ({validateAppointment, handleBack, handleSubmitAppoint, handleValidate}) => {
	return (
		<div className="form-submit align-center">
			{
				validateAppointment ? 
				<div>
					<button className="btn_back" onClick={e => handleBack(e)}>
						<span>{lang.label.back}</span>
					</button>
					<button className="btn_send" onClick={e => handleSubmitAppoint(e)}>
						<span>{lang.label.reservation}</span>
					</button>
				</div> :
				<button className="btn_send" onClick={e => handleValidate(e)}>
					<span>{lang.label.confirm_yurikago}</span>
				</button>
			}					
		</div>
	)
}

